import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-switch-to-integrated-modal',
	templateUrl: './switch-to-integrated-modal.component.html',
	standalone: false,
})
export class SwitchToIntegratedModalComponent {
	constructor(
		private dialogRef: MatDialogRef<SwitchToIntegratedModalComponent>,
	) {}

	confirm() {
		this.dialogRef.close(true);
	}

	close() {
		this.dialogRef.close(false);
	}
}
